import type { RouteObject } from 'react-router-dom';

export const workbenchRoutes = [
  {
    path: '/all',
    lazy: () => import('./pages/workspace/all-page/all-page'),
  },
  {
    path: '/task-list',
    lazy: () => import('./pages/workspace/task-page/list/index'),
  },
  {
    path: '/home',
    lazy: () => import('./pages/workspace/home/index'),
  },
  {
    path: '/pay-page',
    lazy: () => import('@affine/core/desktop/pages/workspace/pay-page/index'),
  },
  {
    path: '/knowledge-base',
    lazy: () => import('./pages/workspace/knowledge-base/index'),
  },
  {
    path: '/group',
    lazy: () => import('./pages/workspace/group/index'),
  },
  {
    path: '/collection',
    lazy: () => import('./pages/workspace/all-collection'),
  },
  {
    path: '/collection/:collectionId',
    lazy: () => import('./pages/workspace/collection/index'),
  },
  {
    path: '/tag',
    lazy: () => import('./pages/workspace/all-tag'),
  },
  {
    path: '/tag/:tagId',
    lazy: () => import('./pages/workspace/tag'),
  },
  {
    path: '/trash',
    lazy: () => import('./pages/workspace/trash-page'),
  },
  {
    path: '/:pageId',
    lazy: () => import('./pages/workspace/detail-page/detail-page'),
  },
  {
    path: '/:pageId/attachments/:attachmentId',
    lazy: () => import('./pages/workspace/attachment/index'),
  },
  {
    path: '*',
    lazy: () => import('./pages/404'),
  },
] satisfies RouteObject[];
